module.exports = __webpack_public_path__ + "static/img/大唐萌宫.39ebe0de.png";